unit unit_AenderungKundendaten;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, WEBLib.Grids, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, DB;

type
  TAenderungKundendaten = class(TForm)
    TC: TTableControl;
    xdsLaender: TXDataWebDataSet;
    xdsLaenderLaenderkuerzel: TStringField;
    xdsLaenderLand: TStringField;
    xdsLaenderEULand: TIntegerField;
    xdsKDNAEN: TXDataWebDataSet;
    xdsKDNAENID: TStringField;
    xdsKDNAENKundennummer: TStringField;
    xdsKDNAENNachname: TStringField;
    xdsKDNAENVorname: TStringField;
    xdsKDNAENAdresszeile2: TStringField;
    xdsKDNAENAdresszeile3: TStringField;
    xdsKDNAENStrasse: TStringField;
    xdsKDNAENPostleitzahl: TStringField;
    xdsKDNAENOrt: TStringField;
    xdsKDNAENLaenderkuerzel: TStringField;
    xdsKDNAENLand: TStringField;
    xdsKDNAENTelefonNummer: TStringField;
    xdsKDNAENTelefonAlternativ: TStringField;
    xdsKDNAENTelefaxNummer: TStringField;
    xdsKDNAENMobilTelefon: TStringField;
    xdsKDNAENInternet: TStringField;
    xdsKDNAENEmail: TStringField;
    xdsKDNAENUmsatzsteuerID: TStringField;
    xdsKDNAENAdressanrede: TStringField;
    xdsKDNAENLoginPW: TStringField;
    xdsKDNAENDatumUhrzeit: TDateTimeField;
    xdsKDNAENKeinNewsletter: TBooleanField;
    xdsKDNAENbisher_Nachname: TStringField;
    xdsKDNAENbisher_Vorname: TStringField;
    xdsKDNAENbisher_Adresszeile2: TStringField;
    xdsKDNAENbisher_Adresszeile3: TStringField;
    xdsKDNAENbisher_Strasse: TStringField;
    xdsKDNAENbisher_Postleitzahl: TStringField;
    xdsKDNAENbisher_Ort: TStringField;
    xdsKDNAENbisher_Laenderkuerzel: TStringField;
    xdsKDNAENbisher_Land: TStringField;
    xdsKDNAENbisher_Telefonnummer: TStringField;
    xdsKDNAENbisher_TelefonAlternativ: TStringField;
    xdsKDNAENbisher_TelefaxNummer: TStringField;
    xdsKDNAENbisher_MobilTelefon: TStringField;
    xdsKDNAENbisher_Internet: TStringField;
    xdsKDNAENbisher_Email: TStringField;
    xdsKDNAENbisher_Adressanrede: TStringField;
    xdsKDNAENPruefungErledigt: TDateTimeField;
    xdsKundendaten: TXDataWebDataSet;
    xdsKundendatenKundennummer: TStringField;
    xdsKundendatenGruppeKunden: TBooleanField;
    xdsKundendatenGruppeLieferanten: TBooleanField;
    xdsKundendatenGruppeSonstige: TBooleanField;
    xdsKundendatenGruppeNichtkunden: TBooleanField;
    xdsKundendatenKontaktgruppe: TStringField;
    xdsKundendatenNachname: TStringField;
    xdsKundendatenVorname: TStringField;
    xdsKundendatenAdresszeile2: TStringField;
    xdsKundendatenAdresszeile3: TStringField;
    xdsKundendatenStrasse: TStringField;
    xdsKundendatenPostleitzahl: TStringField;
    xdsKundendatenOrt: TStringField;
    xdsKundendatenLaenderkuerzel: TStringField;
    xdsKundendatenLand: TStringField;
    xdsKundendatenLaenderkennzeichen: TBooleanField;
    xdsKundendatenAdressanrede: TStringField;
    xdsKundendatenBriefanrede1: TStringField;
    xdsKundendatenAdresseBild: TStringField;
    xdsKundendatenLieferanschrift: TStringField;
    xdsKundendatenTelefonNummer: TStringField;
    xdsKundendatenTelefaxNummer: TStringField;
    xdsKundendatenMobilTelefon: TStringField;
    xdsKundendatenEMail: TStringField;
    xdsKundendatenInternet: TStringField;
    xdsKundendatenUmsatzsteuerID: TStringField;
    xdsKundendatenUmsatzsteuerausweis: TBooleanField;
    xdsKundendatenZahlungsbedingung: TIntegerField;
    xdsKundendatenTransportbedingung: TStringField;
    xdsKundendatenKeinNewsletter: TBooleanField;
    xdsKundendatenTelefonAlternativ: TStringField;
    xdsKundendatenTitel: TStringField;
    xdsKundendatenKundenklasseFarbe: TIntegerField;
    xdsKundendatenRechnungEmail: TStringField;
    xdsKundendatenLoginPW: TStringField;
    xdsKundendatenBesteuerungKey: TIntegerField;
    xdsKundendatenAuftraegeJahr: TFloatField;
    xdsKundendatenAuftraegeVorjahr: TFloatField;
    xdsKundendatenLieferadresseID: TIntegerField;
    xdsKundendatenUSTIDgeprueft: TDateTimeField;
    xdsKundendatenKontaktverbund: TStringField;
    xdsKundendatenHinweis: TStringField;
    xdsKundendatenLatitude: TFloatField;
    xdsKundendatenLongitude: TFloatField;
    xdsKundendatenkmLuftlinie: TFloatField;
    xdsKundendatenGoogleID: TStringField;
    xdsKundendatenGoogleUpdatedUTC: TDateTimeField;
    xdsKundendatenBundesland: TStringField;
    xdsKundendatenRegion: TStringField;
    xdsKundendatenMandatsreferenz: TStringField;
    xdsKundendatenMandatsreferenzVom: TDateTimeField;
    xdsKundendatenLastschriftArt: TStringField;
    xdsKundendatenMahnsperre: TBooleanField;
    xdsKundendatenSuchbegriff: TStringField;
    xdsKundendatenLieferanschriftDaten: TStringField;
    xdsKundendatenExportKasse: TBooleanField;
    xdsKundendatenLoeschvormerkungDatum: TDateTimeField;
    xdsKundendatenLoeschvormerkungGrund: TStringField;
    xdsKundendatenPseudonymisiert: TStringField;
    xdsKundendatenLoginAktiv: TIntegerField;
    xdsKundendatenSonstigeDaten: TStringField;
    WebMessageDlg1: TMessageDlg;
    xdsProtokoll: TXDataWebDataSet;
    xdsProtokollID: TIntegerField;
    xdsProtokollDatum: TDateTimeField;
    xdsProtokollKundennummer: TStringField;
    xdsProtokollNotiz: TStringField;
    xdsProtokollPruefungErforderlich: TBooleanField;
    xdsProtokollPruefungErledigt: TDateTimeField;
    xdsProtokollPruefungErledigtDurch: TStringField;
    xdsProtokollBemerkung: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsLaenderAfterOpen(DataSet: TDataSet);
    procedure xdsKDNAENAfterOpen(DataSet: TDataSet);
    procedure xdsKundendatenAfterOpen(DataSet: TDataSet);
    procedure xdsKDNAENAfterPost(DataSet: TDataSet);
    procedure xdsKDNAENAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure xdsKundendatenAfterPost(DataSet: TDataSet);
    procedure xdsKundendatenAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure xdsProtokollAfterOpen(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    btnAbsenden:TButton;
    buttonzurueck:TButton;
    procedure btnAbsendenclick(Sender:TObject);
    procedure buttonzurueckclick(Sender:TObject);
    procedure FormularErstellen;
  protected procedure LoadDFMValues; override; end;

var
  AenderungKundendaten: TAenderungKundendaten;
  edtAdressanrede:TComboBox;
  edtNachname:TEdit;
  edtVorname:TEdit;
  edtAdresszeile2:TEdit;
  edtAdresszeile3:TEdit;
  edtStrasse:TEdit;
  edtPostleitzahl:TEdit;
  edtOrt:TEdit;
  edtLand:TComboBox;
  edtTelefon1:TEdit;
  edtTelefon2:TEdit;
  edtTelefonMobil:TEdit;
  edtInternet:TEdit;


implementation
  uses unit1, unit2;
{$R *.dfm}

procedure TAenderungKundendaten.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TAenderungKundendaten.btnAbsendenclick(Sender: TObject);
Var
  adrbild:string;
begin
    if edtNachname.Text='' then
    begin
      showmessage('Sie müssen einen Nachnamen eingeben');
      exit;
    end;
    if edtStrasse.Text='' then
    begin
      showmessage('Sie müssen die Strasse eingeben');
      exit;
    end;
    if edtPostleitzahl.Text='' then
    begin
      showmessage('Sie müssen die Postleitzahl eingeben');
      exit;
    end;
    if edtOrt.Text='' then
    begin
      showmessage('Sie müssen den Ort eingeben');
      exit;
    end;
    if edtLand.Text='' then
    begin
      showmessage('Sie müssen das Land auswählen');
      exit;
    end;

    if (edtTelefon1.Text='') AND (edtTelefon2.Text='') AND (edtTelefonMobil.Text='') then
    begin
      showmessage('Sie müssen mindestens eine Telefonnummer eintragen');
      exit;
    end;

    xdsProtokoll.Append;
    xdsProtokollDatum.AsDateTime:=date+time;
    xdsProtokollKundennummer.AsString:=xdsKundendatenKundennummer.AsString;
    xdsProtokollPruefungErforderlich.AsBoolean:=true;
    xdsProtokollNotiz.AsString:='Kundendaten geändert, Prüfung vornehmen '+InternetIpAdresse;
    xdsProtokoll.Post;
    xdsProtokoll.ApplyUpdates;

    xdsKDNAEN.Append;
    xdsKDNAENKundennummer.AsString:=xdsKundendatenKundennummer.AsString;
    xdsKDNAENbisher_Nachname.AsString:=xdsKundendatenNachname.AsString;
    xdsKDNAENbisher_Vorname.AsString:=xdsKundendatenVorname.AsString;
    xdsKDNAENbisher_Adresszeile2.asstring:=xdsKundendatenAdresszeile2.asstring;
    xdsKDNAENbisher_Adresszeile3.asstring:=xdsKundendatenAdresszeile3.asstring;
    xdsKDNAENbisher_Strasse.asstring:=xdsKundendatenStrasse.asstring;
    xdsKDNAENbisher_Postleitzahl.asstring:=xdsKundendatenPostleitzahl.asstring;
    xdsKDNAENbisher_Ort.asstring:=xdsKundendatenOrt.asstring;
    xdsKDNAENbisher_Land.asstring:=xdsKundendatenLand.asstring;
    xdsKDNAENbisher_Laenderkuerzel.asstring:=xdsKundendatenLaenderkuerzel.asstring;
    xdsKDNAENbisher_TelefonNummer.asstring:=xdsKundendatenTelefonNummer.asstring;
    xdsKDNAENbisher_TelefonAlternativ.asstring:=xdsKundendatenTelefonAlternativ.asstring;
    xdsKDNAENbisher_MobilTelefon.asstring:=xdsKundendatenMobilTelefon.asstring;
    xdsKDNAENbisher_Internet.asstring:=xdsKundendatenInternet.asstring;
    xdsKDNAENbisher_Adressanrede.asstring:=xdsKundendatenAdressanrede.asstring;

    xdsKDNAENNachname.AsString:=edtNachname.Text;
    xdsKDNAENVorname.AsString:=edtVorname.Text;
    xdsKDNAENAdresszeile2.AsString:=edtAdresszeile2.Text;
    xdsKDNAENAdresszeile3.AsString:=edtAdresszeile3.Text;
    xdsKDNAENStrasse.AsString:=edtStrasse.Text;
    xdsKDNAENPostleitzahl.AsString:=edtPostleitzahl.Text;
    xdsKDNAENOrt.AsString:=edtOrt.Text;
    xdsKDNAENLand.AsString:=edtLand.Text;
    xdsLaender.Locate('Land',edtLand.Text,[]);
    xdsKDNAENLaenderkuerzel.AsString:=xdsLaenderLaenderkuerzel.AsString;
    xdsKDNAENTelefonNummer.AsString:=edtTelefon1.Text;
    xdsKDNAENTelefonAlternativ.AsString:=edtTelefon2.Text;
    xdsKDNAENMobilTelefon.AsString:=edtTelefonMobil.Text;
    xdsKDNAENInternet.AsString:=edtInternet.Text;
    xdsKDNAENAdressanrede.AsString:=edtAdressanrede.Text;
    xdsKDNAENDatumUhrzeit.Asdatetime:=date+time;
    xdsKDNAEN.Post;

    xdsKundendaten.edit;
    xdsKundendatenNachname.AsString:=edtNachname.Text;
    xdsKundendatenVorname.AsString:=edtVorname.Text;
    xdsKundendatenAdresszeile2.AsString:=edtAdresszeile2.Text;
    xdsKundendatenAdresszeile3.AsString:=edtAdresszeile3.Text;
    xdsKundendatenStrasse.AsString:=edtStrasse.Text;
    xdsKundendatenPostleitzahl.AsString:=edtPostleitzahl.Text;
    xdsKundendatenOrt.AsString:=edtOrt.Text;
    xdsKundendatenLand.AsString:=edtLand.Text;
    xdsLaender.Locate('Land',edtLand.Text,[]);
    xdsKundendatenLaenderkuerzel.AsString:=xdsLaenderLaenderkuerzel.AsString;
    xdsKundendatenTelefonNummer.AsString:=edtTelefon1.Text;
    xdsKundendatenTelefonAlternativ.AsString:=edtTelefon2.Text;
    xdsKundendatenMobilTelefon.AsString:=edtTelefonMobil.Text;
    xdsKundendatenInternet.AsString:=edtInternet.Text;
    xdsKundendatenAdressanrede.AsString:=edtAdressanrede.Text;

    if xdskundendatenLaenderkuerzel.asstring<>dm2.tablesysdatlaenderkuerzel.asstring then xdsKundendatenLaenderkennzeichen.asboolean:=TRUE ELSE  xdsKundendatenLaenderkennzeichen.asboolean:=FALSE;


    adrbild:='';
    if (length(xdsKundendatenadressanrede.asstring)>1) then
    begin
    adrbild:=adrbild + xdsKundendatenadressanrede.asstring+chr(13)+chr(10);
    end;
    if (length(xdsKundendatentitel.asstring)>1) then
    begin
    adrbild:=adrbild + xdsKundendatentitel.asstring+' ';
    end;
    if length(xdsKundendatenvorname.asstring)>1 then
    begin
    adrbild:=adrbild + xdsKundendatenvorname.asstring+' ';
    end;
    adrbild:=adrbild + xdsKundendatennachname.asstring+chr(13)+chr(10);
    if length(xdsKundendatenAdresszeile2.asstring)>0 then
    begin
    adrbild:=adrbild + xdsKundendatenadresszeile2.asstring+chr(13)+chr(10);
    end;
    if length(xdsKundendatenAdresszeile3.asstring)>0 then
    begin
    adrbild:=adrbild + xdsKundendatenadresszeile3.asstring+chr(13)+chr(10);
    end;
    adrbild:=adrbild + xdsKundendatenstrasse.asstring+chr(13)+chr(10);
    if xdsKundendatenLaenderkennzeichen.asboolean=true then
    begin
    adrbild:=adrbild + xdsKundendatenpostleitzahl.asstring+ ' ';
    adrbild:=adrbild + uppercase(xdsKundendatenort.asstring)+chr(13)+chr(10);
    adrbild:=adrbild + uppercase(xdsKundendatenland.asstring);
    end
    else
    begin
    adrbild:=adrbild + xdsKundendatenpostleitzahl.asstring+ ' ';
    adrbild:=adrbild + xdsKundendatenort.asstring+chr(13)+chr(10);
    end;
    xdsKundendatenAdresseBild.asstring:=adrbild;

    if xdsKundendatenLaenderkuerzel.asstring='AT' then
    begin
      xdsKundendatenUmsatzsteuerausweis.asboolean:=TRUE;
      xdsKundendatenBesteuerungKey.asinteger:=1;
      if xdsKundendatenUmsatzsteuerID.asstring='Drittand' then xdsKundendatenUmsatzsteuerID.asstring:='';
    end
    else
    begin
      if xdslaenderEULand.asinteger=1 then
      begin
        if xdsKundendatenUmsatzsteuerID.asstring<>'' then
        begin
          xdsKundendatenUmsatzsteuerausweis.asboolean:=FALSE;
          xdsKundendatenBesteuerungKey.asinteger:=2;
        end
        else
        begin
          xdsKundendatenUmsatzsteuerausweis.asboolean:=TRUE;
          xdsKundendatenBesteuerungKey.asinteger:=4;
        end;
      end
      else
      begin
        if xdsKundendatenLaenderkuerzel.asstring='CH' then
        begin
          xdsKundendatenUmsatzsteuerausweis.asboolean:=FALSE;
          xdsKundendatenUmsatzsteuerID.asstring:='Drittand';
          xdsKundendatenBesteuerungKey.asinteger:=3;
        end
        else
        begin
          xdsKundendatenUmsatzsteuerausweis.asboolean:=TRUE;
          xdsKundendatenUmsatzsteuerID.asstring:='';
          xdsKundendatenBesteuerungKey.asinteger:=4;
        end;
      end;

    end;
    xdsKundendaten.post;
end;

procedure TAenderungKundendaten.FormularErstellen;
var
  myelement:TJSHTMLElement;
  i:integer;
begin
  TC.ColCount:=1;
  TC.RowCount:=17;

  TC.Cells[0,0]:='<h4>Änderung Stammdaten';
  inc(i);
  myelement:=TC.cellelements[0,i];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Adressanrede*<br>';
  myelement:=TC.CellElements[0,i];
  edtAdressanrede:=TComboBox.Create(self);
  edtAdressanrede.ElementClassName:='form-control';
  edtAdressanrede.Width:=200;
  edtAdressanrede.HeightStyle:=ssAuto;

  edtAdressanrede.ItemIndex:=-1;
  edtAdressanrede.ParentElement:=myelement;
  edtAdressanrede.Items.Clear;
  edtAdressanrede.Items.Add('Firma');
  edtAdressanrede.Items.Add('Herrn');
  edtAdressanrede.Items.Add('Frau');
  edtadressanrede.Text:=xdsKundendatenAdressanrede.AsString;
  inc(i);
  TC.Cells[0,i]:='Nachname/Firma*<br>';
  myelement:=TC.CellElements[0,i];
  edtNachname:=TEdit.Create(self);
  edtNachname.ElementClassName:='form-control';
  edtNachname.Width:=400;
  edtNachname.HeightStyle:=ssAuto;
  edtNachname.TextHint:='Nachname/Firma';
  edtNachname.MaxLength:=40;
  edtNachname.Text:=xdsKundendatenNachname.AsString;
  edtNachname.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Vorname<br>';
  myelement:=TC.CellElements[0,i];
  edtVorname:=TEdit.Create(self);
  edtVorname.ElementClassName:='form-control';
  edtVorname.Width:=400;
  edtVorname.HeightStyle:=ssAuto;
  edtVorname.TextHint:='Vorname(wenn keine eingetragene Firma)';
  edtVorname.MaxLength:=40;
  edtVorname.Text:=xdsKundendatenVorname.AsString;
  edtVorname.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Adresszeile2<br>';
  myelement:=TC.CellElements[0,i];
  edtAdresszeile2:=TEdit.Create(self);
  edtAdresszeile2.ElementClassName:='form-control';
  edtAdresszeile2.Width:=400;
  edtAdresszeile2.HeightStyle:=ssAuto;
  edtAdresszeile2.TextHint:='Adresszeile2(wenn mehr Platz benötigt)';
  edtAdresszeile2.MaxLength:=40;
  edtadresszeile2.Text:=xdsKundendatenAdresszeile2.AsString;
  edtAdresszeile2.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Adresszeile3<br>';
  myelement:=TC.CellElements[0,i];
  edtAdresszeile3:=TEdit.Create(self);
  edtAdresszeile3.ElementClassName:='form-control';
  edtAdresszeile3.Width:=400;
  edtAdresszeile3.HeightStyle:=ssAuto;
  edtAdresszeile3.TextHint:='Adresszeile3(wenn mehr Platz benötigt)';
  edtAdresszeile3.MaxLength:=40;
  edtadresszeile3.Text:=xdsKundendatenAdresszeile3.AsString;
  edtAdresszeile3.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Strasse*<br>';
  myelement:=TC.CellElements[0,i];
  edtStrasse:=TEdit.Create(self);
  edtStrasse.ElementClassName:='form-control';
  edtStrasse.Width:=400;
  edtStrasse.HeightStyle:=ssAuto;
  edtStrasse.TextHint:='Strasse und Hausnummer';
  edtStrasse.MaxLength:=40;
  edtstrasse.Text:=xdsKundendatenStrasse.AsString;
  edtStrasse.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Postleitzahl*<br>';
  myelement:=TC.CellElements[0,i];
  edtPostleitzahl:=TEdit.Create(self);
  edtPostleitzahl.ElementClassName:='form-control';
  edtPostleitzahl.Width:=100;
  edtPostleitzahl.HeightStyle:=ssAuto;
  edtPostleitzahl.TextHint:='Postleitzahl';
  edtPostleitzahl.MaxLength:=6;
  edtPostleitzahl.Text:=xdsKundendatenPostleitzahl.AsString;
  edtPostleitzahl.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Ort*<br>';
  myelement:=TC.CellElements[0,i];
  edtOrt:=TEdit.Create(self);
  edtOrt.ElementClassName:='form-control';
  edtOrt.Width:=400;
  edtOrt.HeightStyle:=ssAuto;
  edtOrt.TextHint:='Ort';
  edtOrt.MaxLength:=40;
  edtOrt.Text:=xdsKundendatenOrt.AsString;
  edtOrt.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Land*<br>';
  myelement:=TC.CellElements[0,i];
  edtLand:=TComboBox.Create(self);
  edtLand.ElementClassName:='form-control';
  edtLand.Width:=400;
  edtLand.HeightStyle:=ssAuto;

  edtLand.ItemIndex:=-1;

  edtLand.ParentElement:=myelement;
  edtland.Items.Clear;
  xdsLaender.First;
  while not xdslaender.eof do
  begin
    edtland.Items.Add(xdsLaenderLand.asstring);
    xdslaender.Next;
  end;
  edtLand.Text:=xdsKundendatenLand.AsString;

  inc(i);
  TC.Cells[0,i]:='Telefon*<br>';
  myelement:=TC.CellElements[0,i];
  edtTelefon1:=TEdit.Create(self);
  edtTelefon1.ElementClassName:='form-control';
  edtTelefon1.Width:=300;
  edtTelefon1.HeightStyle:=ssAuto;
  edtTelefon1.TextHint:='Telefon';
  edtTelefon1.MaxLength:=25;
  edtTelefon1.Text:=xdsKundendatenTelefonNummer.AsString;
  edtTelefon1.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Telefon (alternativ)<br>';
  myelement:=TC.CellElements[0,i];
  edtTelefon2:=TEdit.Create(self);
  edtTelefon2.ElementClassName:='form-control';
  edtTelefon2.Width:=300;
  edtTelefon2.HeightStyle:=ssAuto;
  edtTelefon2.TextHint:='Telefon';
  edtTelefon2.MaxLength:=25;
  edtTelefon2.Text:=xdsKundendatenTelefonAlternativ.AsString;
  edtTelefon2.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Telefon Mobil<br>';
  myelement:=TC.CellElements[0,i];
  edtTelefonMobil:=TEdit.Create(self);
  edtTelefonMobil.ElementClassName:='form-control';
  edtTelefonMobil.Width:=300;
  edtTelefonMobil.HeightStyle:=ssAuto;
  edtTelefonMobil.TextHint:='Telefon Mobil';
  edtTelefonMobil.MaxLength:=25;
  edtTelefonMobil.Text:=xdsKundendatenMobilTelefon.AsString;
  edtTelefonMobil.ParentElement:=myelement;

  inc(i);
  TC.Cells[0,i]:='Internetadresse<br>';
  myelement:=TC.CellElements[0,i];
  edtInternet:=TEdit.Create(self);
  edtInternet.ElementClassName:='form-control';
  edtInternet.Width:=400;
  edtInternet.HeightStyle:=ssAuto;
  edtInternet.TextHint:='Ihre Internetadresse';
  edtInternet.MaxLength:=50;
  edtInternet.Text:=xdsKundendatenInternet.AsString;
  edtInternet.ParentElement:=myelement;
  inc(i);
  myelement:=TC.cellelements[0,i];
  btnAbsenden:=TButton.Create(self);
  btnAbsenden.ElementClassName:='btn btn-info text-left';
  btnAbsenden.HeightStyle:=ssauto;
  btnAbsenden.WidthStyle:=ssauto;
  btnAbsenden.tag:=0;
  btnAbsenden.Caption:='Änderungen speichern';
  btnAbsenden.OnClick:=@btnAbsendenClick;
  btnAbsenden.ParentElement:=myelement;

  buttonzurueck.setfocus;
  edtAdressanrede.SetFocus;
  TC.Cells[0,0]:='<h4>Änderung Stammdaten';

end;

procedure TAenderungKundendaten.WebFormShow(Sender: TObject);
begin
  xdsProtokoll.Load;

end;

procedure TAenderungKundendaten.xdsKDNAENAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;

end;

procedure TAenderungKundendaten.xdsKDNAENAfterOpen(DataSet: TDataSet);
begin
  xdsKundendaten.Close;
  xdsKundendaten.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer);
  xdsKundendaten.Load;

end;

procedure TAenderungKundendaten.xdsKDNAENAfterPost(DataSet: TDataSet);
begin
  xdsKDNAEN.applyupdates;
end;

procedure TAenderungKundendaten.xdsKundendatenAfterApplyUpdates(
  Sender: TDataSet; Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  if info.Records[0].Error='' then
  begin
    showmessage('Ihre Kundendatenänderung wurde durchgeführt.');
    close;
  end;
end;

procedure TAenderungKundendaten.xdsKundendatenAfterOpen(DataSet: TDataSet);
begin
  FormularErstellen;
end;

procedure TAenderungKundendaten.xdsKundendatenAfterPost(DataSet: TDataSet);
begin
  xdsKundendaten.ApplyUpdates;
end;

procedure TAenderungKundendaten.xdsLaenderAfterOpen(DataSet: TDataSet);
begin
  xdsKdnAen.Load;

end;

procedure TAenderungKundendaten.xdsProtokollAfterOpen(DataSet: TDataSet);
begin
  xdsLaender.Load;
end;

procedure TAenderungKundendaten.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  WebMessageDlg1 := TMessageDlg.Create(Self);
  xdsLaender := TXDataWebDataSet.Create(Self);
  xdsLaenderLaenderkuerzel := TStringField.Create(Self);
  xdsLaenderLand := TStringField.Create(Self);
  xdsLaenderEULand := TIntegerField.Create(Self);
  xdsKDNAEN := TXDataWebDataSet.Create(Self);
  xdsKDNAENID := TStringField.Create(Self);
  xdsKDNAENKundennummer := TStringField.Create(Self);
  xdsKDNAENNachname := TStringField.Create(Self);
  xdsKDNAENVorname := TStringField.Create(Self);
  xdsKDNAENAdresszeile2 := TStringField.Create(Self);
  xdsKDNAENAdresszeile3 := TStringField.Create(Self);
  xdsKDNAENStrasse := TStringField.Create(Self);
  xdsKDNAENPostleitzahl := TStringField.Create(Self);
  xdsKDNAENOrt := TStringField.Create(Self);
  xdsKDNAENLaenderkuerzel := TStringField.Create(Self);
  xdsKDNAENLand := TStringField.Create(Self);
  xdsKDNAENTelefonNummer := TStringField.Create(Self);
  xdsKDNAENTelefonAlternativ := TStringField.Create(Self);
  xdsKDNAENTelefaxNummer := TStringField.Create(Self);
  xdsKDNAENMobilTelefon := TStringField.Create(Self);
  xdsKDNAENInternet := TStringField.Create(Self);
  xdsKDNAENEmail := TStringField.Create(Self);
  xdsKDNAENUmsatzsteuerID := TStringField.Create(Self);
  xdsKDNAENAdressanrede := TStringField.Create(Self);
  xdsKDNAENLoginPW := TStringField.Create(Self);
  xdsKDNAENDatumUhrzeit := TDateTimeField.Create(Self);
  xdsKDNAENKeinNewsletter := TBooleanField.Create(Self);
  xdsKDNAENbisher_Nachname := TStringField.Create(Self);
  xdsKDNAENbisher_Vorname := TStringField.Create(Self);
  xdsKDNAENbisher_Adresszeile2 := TStringField.Create(Self);
  xdsKDNAENbisher_Adresszeile3 := TStringField.Create(Self);
  xdsKDNAENbisher_Strasse := TStringField.Create(Self);
  xdsKDNAENbisher_Postleitzahl := TStringField.Create(Self);
  xdsKDNAENbisher_Ort := TStringField.Create(Self);
  xdsKDNAENbisher_Laenderkuerzel := TStringField.Create(Self);
  xdsKDNAENbisher_Land := TStringField.Create(Self);
  xdsKDNAENbisher_Telefonnummer := TStringField.Create(Self);
  xdsKDNAENbisher_TelefonAlternativ := TStringField.Create(Self);
  xdsKDNAENbisher_TelefaxNummer := TStringField.Create(Self);
  xdsKDNAENbisher_MobilTelefon := TStringField.Create(Self);
  xdsKDNAENbisher_Internet := TStringField.Create(Self);
  xdsKDNAENbisher_Email := TStringField.Create(Self);
  xdsKDNAENbisher_Adressanrede := TStringField.Create(Self);
  xdsKDNAENPruefungErledigt := TDateTimeField.Create(Self);
  xdsKundendaten := TXDataWebDataSet.Create(Self);
  xdsKundendatenKundennummer := TStringField.Create(Self);
  xdsKundendatenGruppeKunden := TBooleanField.Create(Self);
  xdsKundendatenGruppeLieferanten := TBooleanField.Create(Self);
  xdsKundendatenGruppeSonstige := TBooleanField.Create(Self);
  xdsKundendatenGruppeNichtkunden := TBooleanField.Create(Self);
  xdsKundendatenKontaktgruppe := TStringField.Create(Self);
  xdsKundendatenNachname := TStringField.Create(Self);
  xdsKundendatenVorname := TStringField.Create(Self);
  xdsKundendatenAdresszeile2 := TStringField.Create(Self);
  xdsKundendatenAdresszeile3 := TStringField.Create(Self);
  xdsKundendatenStrasse := TStringField.Create(Self);
  xdsKundendatenPostleitzahl := TStringField.Create(Self);
  xdsKundendatenOrt := TStringField.Create(Self);
  xdsKundendatenLaenderkuerzel := TStringField.Create(Self);
  xdsKundendatenLand := TStringField.Create(Self);
  xdsKundendatenLaenderkennzeichen := TBooleanField.Create(Self);
  xdsKundendatenAdressanrede := TStringField.Create(Self);
  xdsKundendatenBriefanrede1 := TStringField.Create(Self);
  xdsKundendatenAdresseBild := TStringField.Create(Self);
  xdsKundendatenLieferanschrift := TStringField.Create(Self);
  xdsKundendatenTelefonNummer := TStringField.Create(Self);
  xdsKundendatenTelefaxNummer := TStringField.Create(Self);
  xdsKundendatenMobilTelefon := TStringField.Create(Self);
  xdsKundendatenEMail := TStringField.Create(Self);
  xdsKundendatenInternet := TStringField.Create(Self);
  xdsKundendatenUmsatzsteuerID := TStringField.Create(Self);
  xdsKundendatenUmsatzsteuerausweis := TBooleanField.Create(Self);
  xdsKundendatenZahlungsbedingung := TIntegerField.Create(Self);
  xdsKundendatenTransportbedingung := TStringField.Create(Self);
  xdsKundendatenKeinNewsletter := TBooleanField.Create(Self);
  xdsKundendatenTelefonAlternativ := TStringField.Create(Self);
  xdsKundendatenTitel := TStringField.Create(Self);
  xdsKundendatenKundenklasseFarbe := TIntegerField.Create(Self);
  xdsKundendatenRechnungEmail := TStringField.Create(Self);
  xdsKundendatenLoginPW := TStringField.Create(Self);
  xdsKundendatenBesteuerungKey := TIntegerField.Create(Self);
  xdsKundendatenAuftraegeJahr := TFloatField.Create(Self);
  xdsKundendatenAuftraegeVorjahr := TFloatField.Create(Self);
  xdsKundendatenLieferadresseID := TIntegerField.Create(Self);
  xdsKundendatenUSTIDgeprueft := TDateTimeField.Create(Self);
  xdsKundendatenKontaktverbund := TStringField.Create(Self);
  xdsKundendatenHinweis := TStringField.Create(Self);
  xdsKundendatenLatitude := TFloatField.Create(Self);
  xdsKundendatenLongitude := TFloatField.Create(Self);
  xdsKundendatenkmLuftlinie := TFloatField.Create(Self);
  xdsKundendatenGoogleID := TStringField.Create(Self);
  xdsKundendatenGoogleUpdatedUTC := TDateTimeField.Create(Self);
  xdsKundendatenBundesland := TStringField.Create(Self);
  xdsKundendatenRegion := TStringField.Create(Self);
  xdsKundendatenMandatsreferenz := TStringField.Create(Self);
  xdsKundendatenMandatsreferenzVom := TDateTimeField.Create(Self);
  xdsKundendatenLastschriftArt := TStringField.Create(Self);
  xdsKundendatenMahnsperre := TBooleanField.Create(Self);
  xdsKundendatenSuchbegriff := TStringField.Create(Self);
  xdsKundendatenLieferanschriftDaten := TStringField.Create(Self);
  xdsKundendatenExportKasse := TBooleanField.Create(Self);
  xdsKundendatenLoeschvormerkungDatum := TDateTimeField.Create(Self);
  xdsKundendatenLoeschvormerkungGrund := TStringField.Create(Self);
  xdsKundendatenPseudonymisiert := TStringField.Create(Self);
  xdsKundendatenLoginAktiv := TIntegerField.Create(Self);
  xdsKundendatenSonstigeDaten := TStringField.Create(Self);
  xdsProtokoll := TXDataWebDataSet.Create(Self);
  xdsProtokollID := TIntegerField.Create(Self);
  xdsProtokollDatum := TDateTimeField.Create(Self);
  xdsProtokollKundennummer := TStringField.Create(Self);
  xdsProtokollNotiz := TStringField.Create(Self);
  xdsProtokollPruefungErforderlich := TBooleanField.Create(Self);
  xdsProtokollPruefungErledigt := TDateTimeField.Create(Self);
  xdsProtokollPruefungErledigtDurch := TStringField.Create(Self);
  xdsProtokollBemerkung := TStringField.Create(Self);

  TC.BeforeLoadDFMValues;
  WebMessageDlg1.BeforeLoadDFMValues;
  xdsLaender.BeforeLoadDFMValues;
  xdsLaenderLaenderkuerzel.BeforeLoadDFMValues;
  xdsLaenderLand.BeforeLoadDFMValues;
  xdsLaenderEULand.BeforeLoadDFMValues;
  xdsKDNAEN.BeforeLoadDFMValues;
  xdsKDNAENID.BeforeLoadDFMValues;
  xdsKDNAENKundennummer.BeforeLoadDFMValues;
  xdsKDNAENNachname.BeforeLoadDFMValues;
  xdsKDNAENVorname.BeforeLoadDFMValues;
  xdsKDNAENAdresszeile2.BeforeLoadDFMValues;
  xdsKDNAENAdresszeile3.BeforeLoadDFMValues;
  xdsKDNAENStrasse.BeforeLoadDFMValues;
  xdsKDNAENPostleitzahl.BeforeLoadDFMValues;
  xdsKDNAENOrt.BeforeLoadDFMValues;
  xdsKDNAENLaenderkuerzel.BeforeLoadDFMValues;
  xdsKDNAENLand.BeforeLoadDFMValues;
  xdsKDNAENTelefonNummer.BeforeLoadDFMValues;
  xdsKDNAENTelefonAlternativ.BeforeLoadDFMValues;
  xdsKDNAENTelefaxNummer.BeforeLoadDFMValues;
  xdsKDNAENMobilTelefon.BeforeLoadDFMValues;
  xdsKDNAENInternet.BeforeLoadDFMValues;
  xdsKDNAENEmail.BeforeLoadDFMValues;
  xdsKDNAENUmsatzsteuerID.BeforeLoadDFMValues;
  xdsKDNAENAdressanrede.BeforeLoadDFMValues;
  xdsKDNAENLoginPW.BeforeLoadDFMValues;
  xdsKDNAENDatumUhrzeit.BeforeLoadDFMValues;
  xdsKDNAENKeinNewsletter.BeforeLoadDFMValues;
  xdsKDNAENbisher_Nachname.BeforeLoadDFMValues;
  xdsKDNAENbisher_Vorname.BeforeLoadDFMValues;
  xdsKDNAENbisher_Adresszeile2.BeforeLoadDFMValues;
  xdsKDNAENbisher_Adresszeile3.BeforeLoadDFMValues;
  xdsKDNAENbisher_Strasse.BeforeLoadDFMValues;
  xdsKDNAENbisher_Postleitzahl.BeforeLoadDFMValues;
  xdsKDNAENbisher_Ort.BeforeLoadDFMValues;
  xdsKDNAENbisher_Laenderkuerzel.BeforeLoadDFMValues;
  xdsKDNAENbisher_Land.BeforeLoadDFMValues;
  xdsKDNAENbisher_Telefonnummer.BeforeLoadDFMValues;
  xdsKDNAENbisher_TelefonAlternativ.BeforeLoadDFMValues;
  xdsKDNAENbisher_TelefaxNummer.BeforeLoadDFMValues;
  xdsKDNAENbisher_MobilTelefon.BeforeLoadDFMValues;
  xdsKDNAENbisher_Internet.BeforeLoadDFMValues;
  xdsKDNAENbisher_Email.BeforeLoadDFMValues;
  xdsKDNAENbisher_Adressanrede.BeforeLoadDFMValues;
  xdsKDNAENPruefungErledigt.BeforeLoadDFMValues;
  xdsKundendaten.BeforeLoadDFMValues;
  xdsKundendatenKundennummer.BeforeLoadDFMValues;
  xdsKundendatenGruppeKunden.BeforeLoadDFMValues;
  xdsKundendatenGruppeLieferanten.BeforeLoadDFMValues;
  xdsKundendatenGruppeSonstige.BeforeLoadDFMValues;
  xdsKundendatenGruppeNichtkunden.BeforeLoadDFMValues;
  xdsKundendatenKontaktgruppe.BeforeLoadDFMValues;
  xdsKundendatenNachname.BeforeLoadDFMValues;
  xdsKundendatenVorname.BeforeLoadDFMValues;
  xdsKundendatenAdresszeile2.BeforeLoadDFMValues;
  xdsKundendatenAdresszeile3.BeforeLoadDFMValues;
  xdsKundendatenStrasse.BeforeLoadDFMValues;
  xdsKundendatenPostleitzahl.BeforeLoadDFMValues;
  xdsKundendatenOrt.BeforeLoadDFMValues;
  xdsKundendatenLaenderkuerzel.BeforeLoadDFMValues;
  xdsKundendatenLand.BeforeLoadDFMValues;
  xdsKundendatenLaenderkennzeichen.BeforeLoadDFMValues;
  xdsKundendatenAdressanrede.BeforeLoadDFMValues;
  xdsKundendatenBriefanrede1.BeforeLoadDFMValues;
  xdsKundendatenAdresseBild.BeforeLoadDFMValues;
  xdsKundendatenLieferanschrift.BeforeLoadDFMValues;
  xdsKundendatenTelefonNummer.BeforeLoadDFMValues;
  xdsKundendatenTelefaxNummer.BeforeLoadDFMValues;
  xdsKundendatenMobilTelefon.BeforeLoadDFMValues;
  xdsKundendatenEMail.BeforeLoadDFMValues;
  xdsKundendatenInternet.BeforeLoadDFMValues;
  xdsKundendatenUmsatzsteuerID.BeforeLoadDFMValues;
  xdsKundendatenUmsatzsteuerausweis.BeforeLoadDFMValues;
  xdsKundendatenZahlungsbedingung.BeforeLoadDFMValues;
  xdsKundendatenTransportbedingung.BeforeLoadDFMValues;
  xdsKundendatenKeinNewsletter.BeforeLoadDFMValues;
  xdsKundendatenTelefonAlternativ.BeforeLoadDFMValues;
  xdsKundendatenTitel.BeforeLoadDFMValues;
  xdsKundendatenKundenklasseFarbe.BeforeLoadDFMValues;
  xdsKundendatenRechnungEmail.BeforeLoadDFMValues;
  xdsKundendatenLoginPW.BeforeLoadDFMValues;
  xdsKundendatenBesteuerungKey.BeforeLoadDFMValues;
  xdsKundendatenAuftraegeJahr.BeforeLoadDFMValues;
  xdsKundendatenAuftraegeVorjahr.BeforeLoadDFMValues;
  xdsKundendatenLieferadresseID.BeforeLoadDFMValues;
  xdsKundendatenUSTIDgeprueft.BeforeLoadDFMValues;
  xdsKundendatenKontaktverbund.BeforeLoadDFMValues;
  xdsKundendatenHinweis.BeforeLoadDFMValues;
  xdsKundendatenLatitude.BeforeLoadDFMValues;
  xdsKundendatenLongitude.BeforeLoadDFMValues;
  xdsKundendatenkmLuftlinie.BeforeLoadDFMValues;
  xdsKundendatenGoogleID.BeforeLoadDFMValues;
  xdsKundendatenGoogleUpdatedUTC.BeforeLoadDFMValues;
  xdsKundendatenBundesland.BeforeLoadDFMValues;
  xdsKundendatenRegion.BeforeLoadDFMValues;
  xdsKundendatenMandatsreferenz.BeforeLoadDFMValues;
  xdsKundendatenMandatsreferenzVom.BeforeLoadDFMValues;
  xdsKundendatenLastschriftArt.BeforeLoadDFMValues;
  xdsKundendatenMahnsperre.BeforeLoadDFMValues;
  xdsKundendatenSuchbegriff.BeforeLoadDFMValues;
  xdsKundendatenLieferanschriftDaten.BeforeLoadDFMValues;
  xdsKundendatenExportKasse.BeforeLoadDFMValues;
  xdsKundendatenLoeschvormerkungDatum.BeforeLoadDFMValues;
  xdsKundendatenLoeschvormerkungGrund.BeforeLoadDFMValues;
  xdsKundendatenPseudonymisiert.BeforeLoadDFMValues;
  xdsKundendatenLoginAktiv.BeforeLoadDFMValues;
  xdsKundendatenSonstigeDaten.BeforeLoadDFMValues;
  xdsProtokoll.BeforeLoadDFMValues;
  xdsProtokollID.BeforeLoadDFMValues;
  xdsProtokollDatum.BeforeLoadDFMValues;
  xdsProtokollKundennummer.BeforeLoadDFMValues;
  xdsProtokollNotiz.BeforeLoadDFMValues;
  xdsProtokollPruefungErforderlich.BeforeLoadDFMValues;
  xdsProtokollPruefungErledigt.BeforeLoadDFMValues;
  xdsProtokollPruefungErledigtDurch.BeforeLoadDFMValues;
  xdsProtokollBemerkung.BeforeLoadDFMValues;
  try
    Name := 'AenderungKundendaten';
    Width := 213;
    Height := 368;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 193;
    TC.Height := 305;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    WebMessageDlg1.SetParentComponent(Self);
    WebMessageDlg1.Name := 'WebMessageDlg1';
    WebMessageDlg1.Left := 152;
    WebMessageDlg1.Top := 152;
    WebMessageDlg1.Width := 24;
    WebMessageDlg1.Height := 24;
    WebMessageDlg1.Buttons := [mbOK];
    WebMessageDlg1.DialogType := mtInformation;
    WebMessageDlg1.Opacity := 0.200000000000000000;
    xdsLaender.SetParentComponent(Self);
    xdsLaender.Name := 'xdsLaender';
    xdsLaender.AfterOpen := xdsLaenderAfterOpen;
    xdsLaender.EntitySetName := 'Laender';
    xdsLaender.Connection := DM2.XDataWebConnection1;
    xdsLaender.QueryString := '$orderby=Land';
    xdsLaender.Left := 48;
    xdsLaender.Top := 40;
    xdsLaenderLaenderkuerzel.SetParentComponent(xdsLaender);
    xdsLaenderLaenderkuerzel.Name := 'xdsLaenderLaenderkuerzel';
    xdsLaenderLaenderkuerzel.FieldName := 'Laenderkuerzel';
    xdsLaenderLaenderkuerzel.Required := True;
    xdsLaenderLaenderkuerzel.Size := 5;
    xdsLaenderLand.SetParentComponent(xdsLaender);
    xdsLaenderLand.Name := 'xdsLaenderLand';
    xdsLaenderLand.FieldName := 'Land';
    xdsLaenderEULand.SetParentComponent(xdsLaender);
    xdsLaenderEULand.Name := 'xdsLaenderEULand';
    xdsLaenderEULand.FieldName := 'EULand';
    xdsKDNAEN.SetParentComponent(Self);
    xdsKDNAEN.Name := 'xdsKDNAEN';
    xdsKDNAEN.AfterApplyUpdates := xdsKDNAENAfterApplyUpdates;
    xdsKDNAEN.AfterOpen := xdsKDNAENAfterOpen;
    xdsKDNAEN.AfterPost := xdsKDNAENAfterPost;
    xdsKDNAEN.EntitySetName := 'KundenportalKdnAen';
    xdsKDNAEN.Connection := DM2.XDataWebConnection1;
    xdsKDNAEN.QueryTop := 1;
    xdsKDNAEN.Left := 136;
    xdsKDNAEN.Top := 40;
    xdsKDNAENID.SetParentComponent(xdsKDNAEN);
    xdsKDNAENID.Name := 'xdsKDNAENID';
    xdsKDNAENID.FieldName := 'ID';
    xdsKDNAENID.Size := 38;
    xdsKDNAENKundennummer.SetParentComponent(xdsKDNAEN);
    xdsKDNAENKundennummer.Name := 'xdsKDNAENKundennummer';
    xdsKDNAENKundennummer.FieldName := 'Kundennummer';
    xdsKDNAENKundennummer.Size := 13;
    xdsKDNAENNachname.SetParentComponent(xdsKDNAEN);
    xdsKDNAENNachname.Name := 'xdsKDNAENNachname';
    xdsKDNAENNachname.FieldName := 'Nachname';
    xdsKDNAENNachname.Size := 40;
    xdsKDNAENVorname.SetParentComponent(xdsKDNAEN);
    xdsKDNAENVorname.Name := 'xdsKDNAENVorname';
    xdsKDNAENVorname.FieldName := 'Vorname';
    xdsKDNAENVorname.Size := 40;
    xdsKDNAENAdresszeile2.SetParentComponent(xdsKDNAEN);
    xdsKDNAENAdresszeile2.Name := 'xdsKDNAENAdresszeile2';
    xdsKDNAENAdresszeile2.FieldName := 'Adresszeile2';
    xdsKDNAENAdresszeile2.Size := 40;
    xdsKDNAENAdresszeile3.SetParentComponent(xdsKDNAEN);
    xdsKDNAENAdresszeile3.Name := 'xdsKDNAENAdresszeile3';
    xdsKDNAENAdresszeile3.FieldName := 'Adresszeile3';
    xdsKDNAENAdresszeile3.Size := 40;
    xdsKDNAENStrasse.SetParentComponent(xdsKDNAEN);
    xdsKDNAENStrasse.Name := 'xdsKDNAENStrasse';
    xdsKDNAENStrasse.FieldName := 'Strasse';
    xdsKDNAENStrasse.Size := 40;
    xdsKDNAENPostleitzahl.SetParentComponent(xdsKDNAEN);
    xdsKDNAENPostleitzahl.Name := 'xdsKDNAENPostleitzahl';
    xdsKDNAENPostleitzahl.FieldName := 'Postleitzahl';
    xdsKDNAENPostleitzahl.Size := 6;
    xdsKDNAENOrt.SetParentComponent(xdsKDNAEN);
    xdsKDNAENOrt.Name := 'xdsKDNAENOrt';
    xdsKDNAENOrt.FieldName := 'Ort';
    xdsKDNAENOrt.Size := 40;
    xdsKDNAENLaenderkuerzel.SetParentComponent(xdsKDNAEN);
    xdsKDNAENLaenderkuerzel.Name := 'xdsKDNAENLaenderkuerzel';
    xdsKDNAENLaenderkuerzel.FieldName := 'Laenderkuerzel';
    xdsKDNAENLaenderkuerzel.Size := 5;
    xdsKDNAENLand.SetParentComponent(xdsKDNAEN);
    xdsKDNAENLand.Name := 'xdsKDNAENLand';
    xdsKDNAENLand.FieldName := 'Land';
    xdsKDNAENLand.Size := 40;
    xdsKDNAENTelefonNummer.SetParentComponent(xdsKDNAEN);
    xdsKDNAENTelefonNummer.Name := 'xdsKDNAENTelefonNummer';
    xdsKDNAENTelefonNummer.FieldName := 'TelefonNummer';
    xdsKDNAENTelefonNummer.Size := 25;
    xdsKDNAENTelefonAlternativ.SetParentComponent(xdsKDNAEN);
    xdsKDNAENTelefonAlternativ.Name := 'xdsKDNAENTelefonAlternativ';
    xdsKDNAENTelefonAlternativ.FieldName := 'TelefonAlternativ';
    xdsKDNAENTelefonAlternativ.Size := 25;
    xdsKDNAENTelefaxNummer.SetParentComponent(xdsKDNAEN);
    xdsKDNAENTelefaxNummer.Name := 'xdsKDNAENTelefaxNummer';
    xdsKDNAENTelefaxNummer.FieldName := 'TelefaxNummer';
    xdsKDNAENTelefaxNummer.Size := 25;
    xdsKDNAENMobilTelefon.SetParentComponent(xdsKDNAEN);
    xdsKDNAENMobilTelefon.Name := 'xdsKDNAENMobilTelefon';
    xdsKDNAENMobilTelefon.FieldName := 'MobilTelefon';
    xdsKDNAENMobilTelefon.Size := 25;
    xdsKDNAENInternet.SetParentComponent(xdsKDNAEN);
    xdsKDNAENInternet.Name := 'xdsKDNAENInternet';
    xdsKDNAENInternet.FieldName := 'Internet';
    xdsKDNAENInternet.Size := 50;
    xdsKDNAENEmail.SetParentComponent(xdsKDNAEN);
    xdsKDNAENEmail.Name := 'xdsKDNAENEmail';
    xdsKDNAENEmail.FieldName := 'Email';
    xdsKDNAENEmail.Size := 50;
    xdsKDNAENUmsatzsteuerID.SetParentComponent(xdsKDNAEN);
    xdsKDNAENUmsatzsteuerID.Name := 'xdsKDNAENUmsatzsteuerID';
    xdsKDNAENUmsatzsteuerID.FieldName := 'UmsatzsteuerID';
    xdsKDNAENAdressanrede.SetParentComponent(xdsKDNAEN);
    xdsKDNAENAdressanrede.Name := 'xdsKDNAENAdressanrede';
    xdsKDNAENAdressanrede.FieldName := 'Adressanrede';
    xdsKDNAENAdressanrede.Size := 15;
    xdsKDNAENLoginPW.SetParentComponent(xdsKDNAEN);
    xdsKDNAENLoginPW.Name := 'xdsKDNAENLoginPW';
    xdsKDNAENLoginPW.FieldName := 'LoginPW';
    xdsKDNAENDatumUhrzeit.SetParentComponent(xdsKDNAEN);
    xdsKDNAENDatumUhrzeit.Name := 'xdsKDNAENDatumUhrzeit';
    xdsKDNAENDatumUhrzeit.FieldName := 'DatumUhrzeit';
    xdsKDNAENKeinNewsletter.SetParentComponent(xdsKDNAEN);
    xdsKDNAENKeinNewsletter.Name := 'xdsKDNAENKeinNewsletter';
    xdsKDNAENKeinNewsletter.FieldName := 'KeinNewsletter';
    xdsKDNAENbisher_Nachname.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_Nachname.Name := 'xdsKDNAENbisher_Nachname';
    xdsKDNAENbisher_Nachname.FieldName := 'bisher_Nachname';
    xdsKDNAENbisher_Nachname.Size := 40;
    xdsKDNAENbisher_Vorname.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_Vorname.Name := 'xdsKDNAENbisher_Vorname';
    xdsKDNAENbisher_Vorname.FieldName := 'bisher_Vorname';
    xdsKDNAENbisher_Vorname.Size := 40;
    xdsKDNAENbisher_Adresszeile2.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_Adresszeile2.Name := 'xdsKDNAENbisher_Adresszeile2';
    xdsKDNAENbisher_Adresszeile2.FieldName := 'bisher_Adresszeile2';
    xdsKDNAENbisher_Adresszeile2.Size := 40;
    xdsKDNAENbisher_Adresszeile3.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_Adresszeile3.Name := 'xdsKDNAENbisher_Adresszeile3';
    xdsKDNAENbisher_Adresszeile3.FieldName := 'bisher_Adresszeile3';
    xdsKDNAENbisher_Adresszeile3.Size := 40;
    xdsKDNAENbisher_Strasse.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_Strasse.Name := 'xdsKDNAENbisher_Strasse';
    xdsKDNAENbisher_Strasse.FieldName := 'bisher_Strasse';
    xdsKDNAENbisher_Strasse.Size := 40;
    xdsKDNAENbisher_Postleitzahl.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_Postleitzahl.Name := 'xdsKDNAENbisher_Postleitzahl';
    xdsKDNAENbisher_Postleitzahl.FieldName := 'bisher_Postleitzahl';
    xdsKDNAENbisher_Postleitzahl.Size := 6;
    xdsKDNAENbisher_Ort.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_Ort.Name := 'xdsKDNAENbisher_Ort';
    xdsKDNAENbisher_Ort.FieldName := 'bisher_Ort';
    xdsKDNAENbisher_Ort.Size := 40;
    xdsKDNAENbisher_Laenderkuerzel.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_Laenderkuerzel.Name := 'xdsKDNAENbisher_Laenderkuerzel';
    xdsKDNAENbisher_Laenderkuerzel.FieldName := 'bisher_Laenderkuerzel';
    xdsKDNAENbisher_Laenderkuerzel.Size := 5;
    xdsKDNAENbisher_Land.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_Land.Name := 'xdsKDNAENbisher_Land';
    xdsKDNAENbisher_Land.FieldName := 'bisher_Land';
    xdsKDNAENbisher_Land.Size := 40;
    xdsKDNAENbisher_Telefonnummer.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_Telefonnummer.Name := 'xdsKDNAENbisher_Telefonnummer';
    xdsKDNAENbisher_Telefonnummer.FieldName := 'bisher_Telefonnummer';
    xdsKDNAENbisher_Telefonnummer.Size := 25;
    xdsKDNAENbisher_TelefonAlternativ.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_TelefonAlternativ.Name := 'xdsKDNAENbisher_TelefonAlternativ';
    xdsKDNAENbisher_TelefonAlternativ.FieldName := 'bisher_TelefonAlternativ';
    xdsKDNAENbisher_TelefonAlternativ.Size := 25;
    xdsKDNAENbisher_TelefaxNummer.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_TelefaxNummer.Name := 'xdsKDNAENbisher_TelefaxNummer';
    xdsKDNAENbisher_TelefaxNummer.FieldName := 'bisher_TelefaxNummer';
    xdsKDNAENbisher_TelefaxNummer.Size := 25;
    xdsKDNAENbisher_MobilTelefon.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_MobilTelefon.Name := 'xdsKDNAENbisher_MobilTelefon';
    xdsKDNAENbisher_MobilTelefon.FieldName := 'bisher_MobilTelefon';
    xdsKDNAENbisher_MobilTelefon.Size := 25;
    xdsKDNAENbisher_Internet.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_Internet.Name := 'xdsKDNAENbisher_Internet';
    xdsKDNAENbisher_Internet.FieldName := 'bisher_Internet';
    xdsKDNAENbisher_Internet.Size := 50;
    xdsKDNAENbisher_Email.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_Email.Name := 'xdsKDNAENbisher_Email';
    xdsKDNAENbisher_Email.FieldName := 'bisher_Email';
    xdsKDNAENbisher_Email.Size := 50;
    xdsKDNAENbisher_Adressanrede.SetParentComponent(xdsKDNAEN);
    xdsKDNAENbisher_Adressanrede.Name := 'xdsKDNAENbisher_Adressanrede';
    xdsKDNAENbisher_Adressanrede.FieldName := 'bisher_Adressanrede';
    xdsKDNAENbisher_Adressanrede.Size := 15;
    xdsKDNAENPruefungErledigt.SetParentComponent(xdsKDNAEN);
    xdsKDNAENPruefungErledigt.Name := 'xdsKDNAENPruefungErledigt';
    xdsKDNAENPruefungErledigt.FieldName := 'PruefungErledigt';
    xdsKundendaten.SetParentComponent(Self);
    xdsKundendaten.Name := 'xdsKundendaten';
    xdsKundendaten.AfterApplyUpdates := xdsKundendatenAfterApplyUpdates;
    xdsKundendaten.AfterOpen := xdsKundendatenAfterOpen;
    xdsKundendaten.AfterPost := xdsKundendatenAfterPost;
    xdsKundendaten.EntitySetName := 'Adressen';
    xdsKundendaten.Connection := DM2.XDataWebConnection1;
    xdsKundendaten.Left := 40;
    xdsKundendaten.Top := 104;
    xdsKundendatenKundennummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundennummer.Name := 'xdsKundendatenKundennummer';
    xdsKundendatenKundennummer.FieldName := 'Kundennummer';
    xdsKundendatenKundennummer.Size := 13;
    xdsKundendatenGruppeKunden.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeKunden.Name := 'xdsKundendatenGruppeKunden';
    xdsKundendatenGruppeKunden.FieldName := 'GruppeKunden';
    xdsKundendatenGruppeLieferanten.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeLieferanten.Name := 'xdsKundendatenGruppeLieferanten';
    xdsKundendatenGruppeLieferanten.FieldName := 'GruppeLieferanten';
    xdsKundendatenGruppeSonstige.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeSonstige.Name := 'xdsKundendatenGruppeSonstige';
    xdsKundendatenGruppeSonstige.FieldName := 'GruppeSonstige';
    xdsKundendatenGruppeNichtkunden.SetParentComponent(xdsKundendaten);
    xdsKundendatenGruppeNichtkunden.Name := 'xdsKundendatenGruppeNichtkunden';
    xdsKundendatenGruppeNichtkunden.FieldName := 'GruppeNichtkunden';
    xdsKundendatenKontaktgruppe.SetParentComponent(xdsKundendaten);
    xdsKundendatenKontaktgruppe.Name := 'xdsKundendatenKontaktgruppe';
    xdsKundendatenKontaktgruppe.FieldName := 'Kontaktgruppe';
    xdsKundendatenKontaktgruppe.Size := 50;
    xdsKundendatenNachname.SetParentComponent(xdsKundendaten);
    xdsKundendatenNachname.Name := 'xdsKundendatenNachname';
    xdsKundendatenNachname.FieldName := 'Nachname';
    xdsKundendatenNachname.Size := 40;
    xdsKundendatenVorname.SetParentComponent(xdsKundendaten);
    xdsKundendatenVorname.Name := 'xdsKundendatenVorname';
    xdsKundendatenVorname.FieldName := 'Vorname';
    xdsKundendatenVorname.Size := 40;
    xdsKundendatenAdresszeile2.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresszeile2.Name := 'xdsKundendatenAdresszeile2';
    xdsKundendatenAdresszeile2.FieldName := 'Adresszeile2';
    xdsKundendatenAdresszeile2.Size := 40;
    xdsKundendatenAdresszeile3.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresszeile3.Name := 'xdsKundendatenAdresszeile3';
    xdsKundendatenAdresszeile3.FieldName := 'Adresszeile3';
    xdsKundendatenAdresszeile3.Size := 40;
    xdsKundendatenStrasse.SetParentComponent(xdsKundendaten);
    xdsKundendatenStrasse.Name := 'xdsKundendatenStrasse';
    xdsKundendatenStrasse.FieldName := 'Strasse';
    xdsKundendatenStrasse.Size := 40;
    xdsKundendatenPostleitzahl.SetParentComponent(xdsKundendaten);
    xdsKundendatenPostleitzahl.Name := 'xdsKundendatenPostleitzahl';
    xdsKundendatenPostleitzahl.FieldName := 'Postleitzahl';
    xdsKundendatenPostleitzahl.Size := 6;
    xdsKundendatenOrt.SetParentComponent(xdsKundendaten);
    xdsKundendatenOrt.Name := 'xdsKundendatenOrt';
    xdsKundendatenOrt.FieldName := 'Ort';
    xdsKundendatenOrt.Size := 40;
    xdsKundendatenLaenderkuerzel.SetParentComponent(xdsKundendaten);
    xdsKundendatenLaenderkuerzel.Name := 'xdsKundendatenLaenderkuerzel';
    xdsKundendatenLaenderkuerzel.FieldName := 'Laenderkuerzel';
    xdsKundendatenLaenderkuerzel.Size := 5;
    xdsKundendatenLand.SetParentComponent(xdsKundendaten);
    xdsKundendatenLand.Name := 'xdsKundendatenLand';
    xdsKundendatenLand.FieldName := 'Land';
    xdsKundendatenLand.Size := 40;
    xdsKundendatenLaenderkennzeichen.SetParentComponent(xdsKundendaten);
    xdsKundendatenLaenderkennzeichen.Name := 'xdsKundendatenLaenderkennzeichen';
    xdsKundendatenLaenderkennzeichen.FieldName := 'Laenderkennzeichen';
    xdsKundendatenAdressanrede.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdressanrede.Name := 'xdsKundendatenAdressanrede';
    xdsKundendatenAdressanrede.FieldName := 'Adressanrede';
    xdsKundendatenAdressanrede.Size := 15;
    xdsKundendatenBriefanrede1.SetParentComponent(xdsKundendaten);
    xdsKundendatenBriefanrede1.Name := 'xdsKundendatenBriefanrede1';
    xdsKundendatenBriefanrede1.FieldName := 'Briefanrede1';
    xdsKundendatenBriefanrede1.Size := 255;
    xdsKundendatenAdresseBild.SetParentComponent(xdsKundendaten);
    xdsKundendatenAdresseBild.Name := 'xdsKundendatenAdresseBild';
    xdsKundendatenAdresseBild.FieldName := 'AdresseBild';
    xdsKundendatenAdresseBild.Size := 255;
    xdsKundendatenLieferanschrift.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferanschrift.Name := 'xdsKundendatenLieferanschrift';
    xdsKundendatenLieferanschrift.FieldName := 'Lieferanschrift';
    xdsKundendatenLieferanschrift.Size := 255;
    xdsKundendatenTelefonNummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefonNummer.Name := 'xdsKundendatenTelefonNummer';
    xdsKundendatenTelefonNummer.FieldName := 'TelefonNummer';
    xdsKundendatenTelefonNummer.Size := 25;
    xdsKundendatenTelefaxNummer.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefaxNummer.Name := 'xdsKundendatenTelefaxNummer';
    xdsKundendatenTelefaxNummer.FieldName := 'TelefaxNummer';
    xdsKundendatenTelefaxNummer.Size := 25;
    xdsKundendatenMobilTelefon.SetParentComponent(xdsKundendaten);
    xdsKundendatenMobilTelefon.Name := 'xdsKundendatenMobilTelefon';
    xdsKundendatenMobilTelefon.FieldName := 'MobilTelefon';
    xdsKundendatenMobilTelefon.Size := 25;
    xdsKundendatenEMail.SetParentComponent(xdsKundendaten);
    xdsKundendatenEMail.Name := 'xdsKundendatenEMail';
    xdsKundendatenEMail.FieldName := 'EMail';
    xdsKundendatenEMail.Size := 50;
    xdsKundendatenInternet.SetParentComponent(xdsKundendaten);
    xdsKundendatenInternet.Name := 'xdsKundendatenInternet';
    xdsKundendatenInternet.FieldName := 'Internet';
    xdsKundendatenInternet.Size := 50;
    xdsKundendatenUmsatzsteuerID.SetParentComponent(xdsKundendaten);
    xdsKundendatenUmsatzsteuerID.Name := 'xdsKundendatenUmsatzsteuerID';
    xdsKundendatenUmsatzsteuerID.FieldName := 'UmsatzsteuerID';
    xdsKundendatenUmsatzsteuerausweis.SetParentComponent(xdsKundendaten);
    xdsKundendatenUmsatzsteuerausweis.Name := 'xdsKundendatenUmsatzsteuerausweis';
    xdsKundendatenUmsatzsteuerausweis.FieldName := 'Umsatzsteuerausweis';
    xdsKundendatenZahlungsbedingung.SetParentComponent(xdsKundendaten);
    xdsKundendatenZahlungsbedingung.Name := 'xdsKundendatenZahlungsbedingung';
    xdsKundendatenZahlungsbedingung.FieldName := 'Zahlungsbedingung';
    xdsKundendatenTransportbedingung.SetParentComponent(xdsKundendaten);
    xdsKundendatenTransportbedingung.Name := 'xdsKundendatenTransportbedingung';
    xdsKundendatenTransportbedingung.FieldName := 'Transportbedingung';
    xdsKundendatenTransportbedingung.Size := 100;
    xdsKundendatenKeinNewsletter.SetParentComponent(xdsKundendaten);
    xdsKundendatenKeinNewsletter.Name := 'xdsKundendatenKeinNewsletter';
    xdsKundendatenKeinNewsletter.FieldName := 'KeinNewsletter';
    xdsKundendatenTelefonAlternativ.SetParentComponent(xdsKundendaten);
    xdsKundendatenTelefonAlternativ.Name := 'xdsKundendatenTelefonAlternativ';
    xdsKundendatenTelefonAlternativ.FieldName := 'TelefonAlternativ';
    xdsKundendatenTelefonAlternativ.Size := 50;
    xdsKundendatenTitel.SetParentComponent(xdsKundendaten);
    xdsKundendatenTitel.Name := 'xdsKundendatenTitel';
    xdsKundendatenTitel.FieldName := 'Titel';
    xdsKundendatenKundenklasseFarbe.SetParentComponent(xdsKundendaten);
    xdsKundendatenKundenklasseFarbe.Name := 'xdsKundendatenKundenklasseFarbe';
    xdsKundendatenKundenklasseFarbe.FieldName := 'KundenklasseFarbe';
    xdsKundendatenRechnungEmail.SetParentComponent(xdsKundendaten);
    xdsKundendatenRechnungEmail.Name := 'xdsKundendatenRechnungEmail';
    xdsKundendatenRechnungEmail.FieldName := 'RechnungEmail';
    xdsKundendatenRechnungEmail.Size := 50;
    xdsKundendatenLoginPW.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoginPW.Name := 'xdsKundendatenLoginPW';
    xdsKundendatenLoginPW.FieldName := 'LoginPW';
    xdsKundendatenBesteuerungKey.SetParentComponent(xdsKundendaten);
    xdsKundendatenBesteuerungKey.Name := 'xdsKundendatenBesteuerungKey';
    xdsKundendatenBesteuerungKey.FieldName := 'BesteuerungKey';
    xdsKundendatenAuftraegeJahr.SetParentComponent(xdsKundendaten);
    xdsKundendatenAuftraegeJahr.Name := 'xdsKundendatenAuftraegeJahr';
    xdsKundendatenAuftraegeJahr.FieldName := 'AuftraegeJahr';
    xdsKundendatenAuftraegeVorjahr.SetParentComponent(xdsKundendaten);
    xdsKundendatenAuftraegeVorjahr.Name := 'xdsKundendatenAuftraegeVorjahr';
    xdsKundendatenAuftraegeVorjahr.FieldName := 'AuftraegeVorjahr';
    xdsKundendatenLieferadresseID.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferadresseID.Name := 'xdsKundendatenLieferadresseID';
    xdsKundendatenLieferadresseID.FieldName := 'LieferadresseID';
    xdsKundendatenUSTIDgeprueft.SetParentComponent(xdsKundendaten);
    xdsKundendatenUSTIDgeprueft.Name := 'xdsKundendatenUSTIDgeprueft';
    xdsKundendatenUSTIDgeprueft.FieldName := 'USTIDgeprueft';
    xdsKundendatenKontaktverbund.SetParentComponent(xdsKundendaten);
    xdsKundendatenKontaktverbund.Name := 'xdsKundendatenKontaktverbund';
    xdsKundendatenKontaktverbund.FieldName := 'Kontaktverbund';
    xdsKundendatenKontaktverbund.Size := 25;
    xdsKundendatenHinweis.SetParentComponent(xdsKundendaten);
    xdsKundendatenHinweis.Name := 'xdsKundendatenHinweis';
    xdsKundendatenHinweis.FieldName := 'Hinweis';
    xdsKundendatenHinweis.Size := 255;
    xdsKundendatenLatitude.SetParentComponent(xdsKundendaten);
    xdsKundendatenLatitude.Name := 'xdsKundendatenLatitude';
    xdsKundendatenLatitude.FieldName := 'Latitude';
    xdsKundendatenLongitude.SetParentComponent(xdsKundendaten);
    xdsKundendatenLongitude.Name := 'xdsKundendatenLongitude';
    xdsKundendatenLongitude.FieldName := 'Longitude';
    xdsKundendatenkmLuftlinie.SetParentComponent(xdsKundendaten);
    xdsKundendatenkmLuftlinie.Name := 'xdsKundendatenkmLuftlinie';
    xdsKundendatenkmLuftlinie.FieldName := 'kmLuftlinie';
    xdsKundendatenGoogleID.SetParentComponent(xdsKundendaten);
    xdsKundendatenGoogleID.Name := 'xdsKundendatenGoogleID';
    xdsKundendatenGoogleID.FieldName := 'GoogleID';
    xdsKundendatenGoogleID.Size := 50;
    xdsKundendatenGoogleUpdatedUTC.SetParentComponent(xdsKundendaten);
    xdsKundendatenGoogleUpdatedUTC.Name := 'xdsKundendatenGoogleUpdatedUTC';
    xdsKundendatenGoogleUpdatedUTC.FieldName := 'GoogleUpdatedUTC';
    xdsKundendatenBundesland.SetParentComponent(xdsKundendaten);
    xdsKundendatenBundesland.Name := 'xdsKundendatenBundesland';
    xdsKundendatenBundesland.FieldName := 'Bundesland';
    xdsKundendatenBundesland.Size := 50;
    xdsKundendatenRegion.SetParentComponent(xdsKundendaten);
    xdsKundendatenRegion.Name := 'xdsKundendatenRegion';
    xdsKundendatenRegion.FieldName := 'Region';
    xdsKundendatenRegion.Size := 50;
    xdsKundendatenMandatsreferenz.SetParentComponent(xdsKundendaten);
    xdsKundendatenMandatsreferenz.Name := 'xdsKundendatenMandatsreferenz';
    xdsKundendatenMandatsreferenz.FieldName := 'Mandatsreferenz';
    xdsKundendatenMandatsreferenz.Size := 34;
    xdsKundendatenMandatsreferenzVom.SetParentComponent(xdsKundendaten);
    xdsKundendatenMandatsreferenzVom.Name := 'xdsKundendatenMandatsreferenzVom';
    xdsKundendatenMandatsreferenzVom.FieldName := 'MandatsreferenzVom';
    xdsKundendatenLastschriftArt.SetParentComponent(xdsKundendaten);
    xdsKundendatenLastschriftArt.Name := 'xdsKundendatenLastschriftArt';
    xdsKundendatenLastschriftArt.FieldName := 'LastschriftArt';
    xdsKundendatenLastschriftArt.Size := 2;
    xdsKundendatenMahnsperre.SetParentComponent(xdsKundendaten);
    xdsKundendatenMahnsperre.Name := 'xdsKundendatenMahnsperre';
    xdsKundendatenMahnsperre.FieldName := 'Mahnsperre';
    xdsKundendatenSuchbegriff.SetParentComponent(xdsKundendaten);
    xdsKundendatenSuchbegriff.Name := 'xdsKundendatenSuchbegriff';
    xdsKundendatenSuchbegriff.FieldName := 'Suchbegriff';
    xdsKundendatenSuchbegriff.Size := 25;
    xdsKundendatenLieferanschriftDaten.SetParentComponent(xdsKundendaten);
    xdsKundendatenLieferanschriftDaten.Name := 'xdsKundendatenLieferanschriftDaten';
    xdsKundendatenLieferanschriftDaten.FieldName := 'LieferanschriftDaten';
    xdsKundendatenLieferanschriftDaten.Size := 255;
    xdsKundendatenExportKasse.SetParentComponent(xdsKundendaten);
    xdsKundendatenExportKasse.Name := 'xdsKundendatenExportKasse';
    xdsKundendatenExportKasse.FieldName := 'ExportKasse';
    xdsKundendatenLoeschvormerkungDatum.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoeschvormerkungDatum.Name := 'xdsKundendatenLoeschvormerkungDatum';
    xdsKundendatenLoeschvormerkungDatum.FieldName := 'LoeschvormerkungDatum';
    xdsKundendatenLoeschvormerkungGrund.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoeschvormerkungGrund.Name := 'xdsKundendatenLoeschvormerkungGrund';
    xdsKundendatenLoeschvormerkungGrund.FieldName := 'LoeschvormerkungGrund';
    xdsKundendatenLoeschvormerkungGrund.Size := 250;
    xdsKundendatenPseudonymisiert.SetParentComponent(xdsKundendaten);
    xdsKundendatenPseudonymisiert.Name := 'xdsKundendatenPseudonymisiert';
    xdsKundendatenPseudonymisiert.FieldName := 'Pseudonymisiert';
    xdsKundendatenPseudonymisiert.Size := 255;
    xdsKundendatenLoginAktiv.SetParentComponent(xdsKundendaten);
    xdsKundendatenLoginAktiv.Name := 'xdsKundendatenLoginAktiv';
    xdsKundendatenLoginAktiv.FieldName := 'LoginAktiv';
    xdsKundendatenSonstigeDaten.SetParentComponent(xdsKundendaten);
    xdsKundendatenSonstigeDaten.Name := 'xdsKundendatenSonstigeDaten';
    xdsKundendatenSonstigeDaten.FieldName := 'SonstigeDaten';
    xdsKundendatenSonstigeDaten.Size := 255;
    xdsProtokoll.SetParentComponent(Self);
    xdsProtokoll.Name := 'xdsProtokoll';
    xdsProtokoll.AfterOpen := xdsProtokollAfterOpen;
    xdsProtokoll.EntitySetName := 'KundenportalProtokoll';
    xdsProtokoll.Connection := DM2.XDataWebConnection1;
    xdsProtokoll.QueryTop := 1;
    xdsProtokoll.Left := 41;
    xdsProtokoll.Top := 192;
    xdsProtokollID.SetParentComponent(xdsProtokoll);
    xdsProtokollID.Name := 'xdsProtokollID';
    xdsProtokollID.FieldName := 'ID';
    xdsProtokollDatum.SetParentComponent(xdsProtokoll);
    xdsProtokollDatum.Name := 'xdsProtokollDatum';
    xdsProtokollDatum.FieldName := 'Datum';
    xdsProtokollKundennummer.SetParentComponent(xdsProtokoll);
    xdsProtokollKundennummer.Name := 'xdsProtokollKundennummer';
    xdsProtokollKundennummer.FieldName := 'Kundennummer';
    xdsProtokollKundennummer.Size := 13;
    xdsProtokollNotiz.SetParentComponent(xdsProtokoll);
    xdsProtokollNotiz.Name := 'xdsProtokollNotiz';
    xdsProtokollNotiz.FieldName := 'Notiz';
    xdsProtokollNotiz.Size := 250;
    xdsProtokollPruefungErforderlich.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErforderlich.Name := 'xdsProtokollPruefungErforderlich';
    xdsProtokollPruefungErforderlich.FieldName := 'PruefungErforderlich';
    xdsProtokollPruefungErledigt.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErledigt.Name := 'xdsProtokollPruefungErledigt';
    xdsProtokollPruefungErledigt.FieldName := 'PruefungErledigt';
    xdsProtokollPruefungErledigtDurch.SetParentComponent(xdsProtokoll);
    xdsProtokollPruefungErledigtDurch.Name := 'xdsProtokollPruefungErledigtDurch';
    xdsProtokollPruefungErledigtDurch.FieldName := 'PruefungErledigtDurch';
    xdsProtokollPruefungErledigtDurch.Size := 50;
    xdsProtokollBemerkung.SetParentComponent(xdsProtokoll);
    xdsProtokollBemerkung.Name := 'xdsProtokollBemerkung';
    xdsProtokollBemerkung.FieldName := 'Bemerkung';
    xdsProtokollBemerkung.Size := 255;
  finally
    TC.AfterLoadDFMValues;
    WebMessageDlg1.AfterLoadDFMValues;
    xdsLaender.AfterLoadDFMValues;
    xdsLaenderLaenderkuerzel.AfterLoadDFMValues;
    xdsLaenderLand.AfterLoadDFMValues;
    xdsLaenderEULand.AfterLoadDFMValues;
    xdsKDNAEN.AfterLoadDFMValues;
    xdsKDNAENID.AfterLoadDFMValues;
    xdsKDNAENKundennummer.AfterLoadDFMValues;
    xdsKDNAENNachname.AfterLoadDFMValues;
    xdsKDNAENVorname.AfterLoadDFMValues;
    xdsKDNAENAdresszeile2.AfterLoadDFMValues;
    xdsKDNAENAdresszeile3.AfterLoadDFMValues;
    xdsKDNAENStrasse.AfterLoadDFMValues;
    xdsKDNAENPostleitzahl.AfterLoadDFMValues;
    xdsKDNAENOrt.AfterLoadDFMValues;
    xdsKDNAENLaenderkuerzel.AfterLoadDFMValues;
    xdsKDNAENLand.AfterLoadDFMValues;
    xdsKDNAENTelefonNummer.AfterLoadDFMValues;
    xdsKDNAENTelefonAlternativ.AfterLoadDFMValues;
    xdsKDNAENTelefaxNummer.AfterLoadDFMValues;
    xdsKDNAENMobilTelefon.AfterLoadDFMValues;
    xdsKDNAENInternet.AfterLoadDFMValues;
    xdsKDNAENEmail.AfterLoadDFMValues;
    xdsKDNAENUmsatzsteuerID.AfterLoadDFMValues;
    xdsKDNAENAdressanrede.AfterLoadDFMValues;
    xdsKDNAENLoginPW.AfterLoadDFMValues;
    xdsKDNAENDatumUhrzeit.AfterLoadDFMValues;
    xdsKDNAENKeinNewsletter.AfterLoadDFMValues;
    xdsKDNAENbisher_Nachname.AfterLoadDFMValues;
    xdsKDNAENbisher_Vorname.AfterLoadDFMValues;
    xdsKDNAENbisher_Adresszeile2.AfterLoadDFMValues;
    xdsKDNAENbisher_Adresszeile3.AfterLoadDFMValues;
    xdsKDNAENbisher_Strasse.AfterLoadDFMValues;
    xdsKDNAENbisher_Postleitzahl.AfterLoadDFMValues;
    xdsKDNAENbisher_Ort.AfterLoadDFMValues;
    xdsKDNAENbisher_Laenderkuerzel.AfterLoadDFMValues;
    xdsKDNAENbisher_Land.AfterLoadDFMValues;
    xdsKDNAENbisher_Telefonnummer.AfterLoadDFMValues;
    xdsKDNAENbisher_TelefonAlternativ.AfterLoadDFMValues;
    xdsKDNAENbisher_TelefaxNummer.AfterLoadDFMValues;
    xdsKDNAENbisher_MobilTelefon.AfterLoadDFMValues;
    xdsKDNAENbisher_Internet.AfterLoadDFMValues;
    xdsKDNAENbisher_Email.AfterLoadDFMValues;
    xdsKDNAENbisher_Adressanrede.AfterLoadDFMValues;
    xdsKDNAENPruefungErledigt.AfterLoadDFMValues;
    xdsKundendaten.AfterLoadDFMValues;
    xdsKundendatenKundennummer.AfterLoadDFMValues;
    xdsKundendatenGruppeKunden.AfterLoadDFMValues;
    xdsKundendatenGruppeLieferanten.AfterLoadDFMValues;
    xdsKundendatenGruppeSonstige.AfterLoadDFMValues;
    xdsKundendatenGruppeNichtkunden.AfterLoadDFMValues;
    xdsKundendatenKontaktgruppe.AfterLoadDFMValues;
    xdsKundendatenNachname.AfterLoadDFMValues;
    xdsKundendatenVorname.AfterLoadDFMValues;
    xdsKundendatenAdresszeile2.AfterLoadDFMValues;
    xdsKundendatenAdresszeile3.AfterLoadDFMValues;
    xdsKundendatenStrasse.AfterLoadDFMValues;
    xdsKundendatenPostleitzahl.AfterLoadDFMValues;
    xdsKundendatenOrt.AfterLoadDFMValues;
    xdsKundendatenLaenderkuerzel.AfterLoadDFMValues;
    xdsKundendatenLand.AfterLoadDFMValues;
    xdsKundendatenLaenderkennzeichen.AfterLoadDFMValues;
    xdsKundendatenAdressanrede.AfterLoadDFMValues;
    xdsKundendatenBriefanrede1.AfterLoadDFMValues;
    xdsKundendatenAdresseBild.AfterLoadDFMValues;
    xdsKundendatenLieferanschrift.AfterLoadDFMValues;
    xdsKundendatenTelefonNummer.AfterLoadDFMValues;
    xdsKundendatenTelefaxNummer.AfterLoadDFMValues;
    xdsKundendatenMobilTelefon.AfterLoadDFMValues;
    xdsKundendatenEMail.AfterLoadDFMValues;
    xdsKundendatenInternet.AfterLoadDFMValues;
    xdsKundendatenUmsatzsteuerID.AfterLoadDFMValues;
    xdsKundendatenUmsatzsteuerausweis.AfterLoadDFMValues;
    xdsKundendatenZahlungsbedingung.AfterLoadDFMValues;
    xdsKundendatenTransportbedingung.AfterLoadDFMValues;
    xdsKundendatenKeinNewsletter.AfterLoadDFMValues;
    xdsKundendatenTelefonAlternativ.AfterLoadDFMValues;
    xdsKundendatenTitel.AfterLoadDFMValues;
    xdsKundendatenKundenklasseFarbe.AfterLoadDFMValues;
    xdsKundendatenRechnungEmail.AfterLoadDFMValues;
    xdsKundendatenLoginPW.AfterLoadDFMValues;
    xdsKundendatenBesteuerungKey.AfterLoadDFMValues;
    xdsKundendatenAuftraegeJahr.AfterLoadDFMValues;
    xdsKundendatenAuftraegeVorjahr.AfterLoadDFMValues;
    xdsKundendatenLieferadresseID.AfterLoadDFMValues;
    xdsKundendatenUSTIDgeprueft.AfterLoadDFMValues;
    xdsKundendatenKontaktverbund.AfterLoadDFMValues;
    xdsKundendatenHinweis.AfterLoadDFMValues;
    xdsKundendatenLatitude.AfterLoadDFMValues;
    xdsKundendatenLongitude.AfterLoadDFMValues;
    xdsKundendatenkmLuftlinie.AfterLoadDFMValues;
    xdsKundendatenGoogleID.AfterLoadDFMValues;
    xdsKundendatenGoogleUpdatedUTC.AfterLoadDFMValues;
    xdsKundendatenBundesland.AfterLoadDFMValues;
    xdsKundendatenRegion.AfterLoadDFMValues;
    xdsKundendatenMandatsreferenz.AfterLoadDFMValues;
    xdsKundendatenMandatsreferenzVom.AfterLoadDFMValues;
    xdsKundendatenLastschriftArt.AfterLoadDFMValues;
    xdsKundendatenMahnsperre.AfterLoadDFMValues;
    xdsKundendatenSuchbegriff.AfterLoadDFMValues;
    xdsKundendatenLieferanschriftDaten.AfterLoadDFMValues;
    xdsKundendatenExportKasse.AfterLoadDFMValues;
    xdsKundendatenLoeschvormerkungDatum.AfterLoadDFMValues;
    xdsKundendatenLoeschvormerkungGrund.AfterLoadDFMValues;
    xdsKundendatenPseudonymisiert.AfterLoadDFMValues;
    xdsKundendatenLoginAktiv.AfterLoadDFMValues;
    xdsKundendatenSonstigeDaten.AfterLoadDFMValues;
    xdsProtokoll.AfterLoadDFMValues;
    xdsProtokollID.AfterLoadDFMValues;
    xdsProtokollDatum.AfterLoadDFMValues;
    xdsProtokollKundennummer.AfterLoadDFMValues;
    xdsProtokollNotiz.AfterLoadDFMValues;
    xdsProtokollPruefungErforderlich.AfterLoadDFMValues;
    xdsProtokollPruefungErledigt.AfterLoadDFMValues;
    xdsProtokollPruefungErledigtDurch.AfterLoadDFMValues;
    xdsProtokollBemerkung.AfterLoadDFMValues;
  end;
end;

end.